import { ReportReason } from '../types';

export const getReportReviewSheetTemplate = (reportReasons: ReportReason[]) => `
<div>
    <h2 class="pl_headline50">Bitte gib einen Grund an, warum du diese Bewertung melden möchtest:</h2>
    <div class="pl_mt100 pl_mb150 pl_banner pl_hidden pl_banner--error js_pdp_cr_report-review-sheet__error">
        <span><b>Bitte gib einen Grund an.</b></span>
    </div>
    <form class="pl_mt100">
        ${reportReasons
            .map(
                ({ label, description }) => `
        <div class="pl_radio pl_mt75">
            <input
                id="cr_reportReviewSurvey__${label}"
                class="pl_radio__button js_pdp_cr_report-review-list__radio"
                name="cr_reportReviewSurvey"
                type="radio"
                value="${label}"
                data-qa="cr-reportReviewSurvey-reason"
            />
            <label for="cr_reportReviewSurvey__${label}" class="pl_radio__label">${description}</label>
        </div>
        `
            )
            .join('')}
    </form>
    <div class="pl_mt150">
        <div class="pl_copy100 pl_mb100">
            Mit Absenden erkennst du die
            <oc-link-v2 class="js_openInPaliSheet" data-sheet-url="/shoppages/kundenbewertung_datenschutz">
                Datenschutz- und Einsendebedingungen
            </oc-link-v2>
            an.
        </div>
        <oc-button-v1 size="100" variant="primary" class="js_pdp_cr_report-review-sheet__submit">
            Absenden
        </oc-button-v1>
    </div>
</div>
`;
